import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perfilprogramador',
  templateUrl: './perfilprogramador.component.html',
  styleUrls: ['./perfilprogramador.component.css']
})
export class PerfilprogramadorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
